<section class="go-container">
  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <!-- Intro -->
        <p class="go-body-copy">
          The Go Accordion Panel should be used inside of a <code class="code-block--inline">&lt;go-accordion&gt;</code>
          component. See <a [routerLink]="['/ui-kit/accordion']">Accordion</a> for details.
        </p>
      </div>

      <div class="go-column go-column--100">
        <!-- Bindings -->
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">expanded</h4>
        <p class="go-body-copy">
          This binding will expand the panel. This is only true at at first render, depending on the behavior
          of the parent <code class="code-block--inline">go-accordion</code> it will override this.
          Typically, you can set this binding to <code class="code-block--inline">true</code>
          for the first <code class="code-block--inline">go-accordion-panel</code> in the accordion.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">heading (required)</h4>
        <p class="go-body-copy">
          The heading for the panel accepted as a string.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">icon</h4>
        <p class="go-body-copy">
          This will set an icon for the panel, shown to the left of the heading.
        </p>
        <caption>
          Note: the icon will only appear if the parent <code class="code-block--inline">go-accordion</code>
          has <code class="code-block--inline">[showIcons]="true"</code> set.
        </caption>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">persistState</h4>
        <p class="go-body-copy">
          This is defaulted to <code class="code-block--inline">true</code>, but if set to <code class="code-block--inline">false</code>
          it will destroy any components inside of the panel when the panel is closed. This will cause any components
          inside to be recreated when the accordion is opened every time. This is only useful if you are also using an
          <code class="code-block--inline">ng-template</code> to not eager load the data inside the panel.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">removeContentPadding</h4>
        <p class="go-body-copy">
          This bindings sets <code class="code-block--inline">padding: 0;</code> for the panel. By default, this is set
          to <code class="code-block--inline">false</code>.
        </p>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="default">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Default</h2>
      <go-copy cardId="default" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content>
      <div class="go-container">
        <div class="go-column go-column--50">
          <h4 class="go-heading-4 go-heading--underlined">Code</h4>
          <code [highlight]="defaultExample"></code>
        </div>
        <div class="go-column go-column--50">
          <h4 class="go-heading-4 go-heading--underlined">View</h4>
          <go-accordion>
            <go-accordion-panel heading="Test 1" [expanded]="true">
              This is some content for Test 1.
            </go-accordion-panel>
            <go-accordion-panel heading="Test 2">
              This is a second thing. 
            </go-accordion-panel>
            <go-accordion-panel heading="Test 3">
              This is a third thing. 
            </go-accordion-panel>
          </go-accordion>
        </div>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="with-icons">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">With Icons</h2>
      <go-copy cardId="with-icons" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content>
      <div class="go-container">
        <div class="go-column go-column--50">
          <h4 class="go-heading-4 go-heading--underlined">Code</h4>
          <code [highlight]="showIconsExample"></code>
        </div>
        <div class="go-column go-column--50">
          <h4 class="go-heading-4 go-heading--underlined">View</h4>
          <go-accordion [showIcons]="true">
            <go-accordion-panel heading="Test 1" icon="home" [expanded]="true">
              This is some content for Test 1.
            </go-accordion-panel>
            <go-accordion-panel heading="Test 2" icon="settings">
              This is a second thing. 
            </go-accordion-panel>
            <go-accordion-panel heading="Test 3" icon="landscape">
              This is a third thing. 
            </go-accordion-panel>
          </go-accordion>
        </div>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="no-padding">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">No Padding</h2>
      <go-copy cardId="no-padding" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content>
      <div class="go-container">
        <div class="go-column go-column--50">
          <h4 class="go-heading-4 go-heading--underlined">Code</h4>
          <code [highlight]="noPaddingExample"></code>
        </div>
        <div class="go-column go-column--50">
          <h4 class="go-heading-4 go-heading--underlined">View</h4>
          <go-accordion>
            <go-accordion-panel heading="Test 1" icon="home" [expanded]="true" [removeContentPadding]="true">
              This content has no padding.
            </go-accordion-panel>
            <go-accordion-panel heading="Test 2" icon="settings">
              This content has padding.
            </go-accordion-panel>
            <go-accordion-panel heading="Test 3" icon="landscape">
              This content has padding.
            </go-accordion-panel>
          </go-accordion>
        </div>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="delayed-loading">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Delayed Loading</h2>
      <go-copy cardId="delayed-loading" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content>
      <div class="go-container">
        <div class="go-column go-column--100 go-body-copy">
          The content inside of an accordion panel can be delayed in loading until a user expands the 
          panel. This is useful when lots of data is being loaded inside of a child component inside 
          of the panel. This can be done through using an ng-template to wrap the content inside the 
          accordion panel.
        </div>

        <div class="go-column go-column--100">
          <h4 class="go-heading-4 go-heading--underlined">View</h4>
          <go-accordion>
            <go-accordion-panel heading="Not Delayed">
              This content loaded immediately.
            </go-accordion-panel>
            <go-accordion-panel heading="Delay Loading">
              <ng-template #panelContent>
                <app-loading-test></app-loading-test>
              </ng-template>
            </go-accordion-panel>
            <go-accordion-panel heading="Don't Persist State" [persistState]="false">
              <ng-template #panelContent>
                <app-loading-test></app-loading-test>
              </ng-template>
            </go-accordion-panel>
          </go-accordion>
        </div>
        
        <div class="go-column go-column--100">
          <h4 class="go-heading-4 go-heading--underlined">Code</h4>
          <div class="go-container">
            <div class="go-column go-column--50">
              <code [highlight]="delayedLoadingExample"></code>
            </div>
            <div class="go-column go-column--50">
              <code [highlight]="appLoadingTestExample"></code>
            </div>
          </div>
        </div>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="header-template">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Header Template</h2>
      <go-copy cardId="header-template" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>
      <div class="go-column go-column--100 go-body-copy">
        The header inside of an accordion panel can contain additional HTML through an
        Angular Content-Projection slot.
      </div>

      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">View</h4>
        <go-accordion>
          <go-accordion-panel heading="Base Heading">
          </go-accordion-panel>
          <go-accordion-panel heading="Projected Heading">
            <ng-template #headerContent>
              <go-pill [removable]="false">Projected</go-pill>
            </ng-template>
          </go-accordion-panel>
        </go-accordion>
      </div>
      
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">Code</h4>
        <div class="go-container">
          <div class="go-column go-column--100">
            <code [highlight]="headerTemplateExample"></code>
          </div>
        </div>
      </div>
    </div>
  </go-card>
</section>
